<style scoped>
.vital-box {
  padding-bottom: 30px;
}

.vital-footer {
  margin-top: 8px;
}
</style>
<template>
  <el-dialog id="modalDieuTri" ref="modalDieuTriLabel" width="75%" :visible.sync="outerVisible" destroy-on-close>
    <div v-loading="loading">
      <div class="d-flex justify-content-between">
        <div class="fs-24 fw-700 txt-grey-900 text-center w-100">
          <span>PHIẾU ĐIỀU TRỊ</span>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col-md-6">
            <div class="fs-14 fw-500">Chọn mẫu Phiếu điều trị</div>
            <el-select clearable filterable v-model="form.doc_template" class="w-full" placeholder="Chọn mẫu phiếu"
              @change="handleChangeDocTemplate" remote :remote-method="getDocsTemplateList" :loading="loading">
              <el-option v-for="item in docsTemplateList" :key="item.id + 'md'" :label="handleGetTemLabel(item)"
                :value="item.id" />
            </el-select>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-6">
            <label class="fw-700">Tên Phiếu</label>
            <input v-model="form.name" class="form--input txt-grey-900 h-10" />
          </div>
          <div class="col-md-6">
            <label class="fw-700">Ngày tạo Phiếu</label>
            <input type="datetime-local" v-model="form.date" class="form--input txt-grey-900 h-10" />
          </div>
        </div>
        <label class="fw-700 txt-grey-900 mb-2 mt-6">Chẩn đoán</label>
        <div class="d-flex justify-content-between">
          <div class="w-5/12 mr-3">
            <el-select class="w-full" v-model="form.diagnostic_code" filterable remote
              :remote-method="searchDiseaseCodes" placeholder="Chọn mã" @change="setName">
              <el-option v-for="item in icds.data" :key="item.id" :label="item.code" :value="item.code"></el-option>
            </el-select>
          </div>
          <div class="w-100">
            <el-select v-model="form.diagnostic_name" class="w-100" filterable allow-create remote
              :remote-method="searchDiseaseName" placeholder="Chọn tên" @change="setCode">
              <el-option v-for="item in icds.data" :key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </div>
        </div>
        <!-- Vital Signs Block: EHC USAGE (moved lower) -->
        <div class="row mt-4">
          <div class="col-md-6">
            <div class="mb-4 p-3 border border-gray-100 rounded relative vital-box">
              <div class="fw-700 mb-2">Chỉ số sinh tồn</div>
              <div class="row">
                <div class="col-6 mb-2">
                  <label class="form-label">Mạch (lần/phút)</label>
                  <input type="number" v-model.number="form.pulse" class="form--input" min="0" placeholder="Mạch" />
                </div>
                <div class="col-6 mb-2">
                  <label class="form-label">Nhiệt độ (°C)</label>
                  <input type="number" v-model.number="form.temperature" class="form--input" step="0.1" min="0"
                    placeholder="Nhiệt độ" />
                </div>
                <div class="col-6 mb-2">
                  <label class="form-label">Huyết áp tâm trương (mmHg)</label>
                  <input type="number" v-model.number="form.diastolic_pressure" class="form--input" min="0"
                    placeholder="Tâm trương" />
                </div>
                <div class="col-6 mb-2">
                  <label class="form-label">Huyết áp tâm thu (mmHg)</label>
                  <input type="number" v-model.number="form.systolic_pressure" class="form--input" min="0"
                    placeholder="Tâm thu" />
                </div>
                <div class="col-6 mb-2">
                  <label class="form-label">Nhịp thở (lần/phút)</label>
                  <input type="number" v-model.number="form.respiration" class="form--input" min="0"
                    placeholder="Nhịp thở" />
                </div>
                <div class="col-6 mb-2">
                  <label class="form-label">Chiều cao (cm)</label>
                  <input type="number" v-model.number="form.height" class="form--input" min="0"
                    placeholder="Chiều cao" />
                </div>
                <div class="col-6 mb-2">
                  <label class="form-label">Cân nặng (kg)</label>
                  <input type="number" v-model.number="form.weight" class="form--input" min="0"
                    placeholder="Cân nặng" />
                </div>
                <div class="col-6 mb-2">
                  <label class="form-label">SpO₂ (%)</label>
                  <input type="number" v-model.number="form.spo2" class="form--input" min="0" max="100"
                    placeholder="SpO₂" />
                </div>
                <div class="col-12 mb-2">
                  <label class="form-label">Ghi chú</label>
                  <input type="text" v-model="form.note" class="form--input" placeholder="Ghi chú" />
                </div>
              </div>
              <div class="vital-footer">
                <span @click="handleUseVitalsign" class="txt-pri underline cursor-pointer">Sử dụng dữ liệu mới nhất của
                  chỉ số sinh tồn</span>
              </div>
            </div>
            <div class="fw-700 mb-2">Diễn biến bệnh</div>
            <CkeditorNormal id="examination-pdt" @onEditorInput="(t) => { form.examination = t; }"
              :prop_text="form.examination" :class_style="'bg-white p-0 txt-black'"></CkeditorNormal>

            <div class="fw-700 mb-2 mt-6">Khám bệnh</div>
            <CkeditorNormal id="disease_progression-pdt" @onEditorInput="(t) => { form.disease_progression = t; }"
              :prop_text="form.disease_progression" :class_style="'bg-white p-0 txt-black'"></CkeditorNormal>

            <label class="fw-700 txt-grey-900 mb-2 mt-6">Xử trí</label>
            <CkeditorNormal id="solution-pdt" @onEditorInput="(t) => { form.solution = t; }" :prop_text="form.solution"
              :class_style="'bg-white p-0 txt-black'"></CkeditorNormal>
            <!-- <label class="fw-700 txt-grey-900 mb-2 mt-6">Triệu chứng</label>
                <CkeditorNormal
                  id="symptom-pdt"
                  @onEditorInput="
                    (t) => {
                      form.symptom = t;
                    }
                  "
                  :prop_text="form.symptom"
                  :class_style="'bg-white p-0 txt-black'"
                ></CkeditorNormal>-->

            <!-- <label class="fw-700 txt-grey-900 mb-2 mt-6">Bệnh khác</label>
                <CkeditorNormal
                  id="other_disease-pdt"
                  @onEditorInput="
                    (t) => {
                      form.other_disease = t;
                    }
                  "
                  :prop_text="form.other_disease"
                  :class_style="'bg-white p-0 txt-black'"
                ></CkeditorNormal>-->
            <!-- <label class="fw-700 txt-grey-900 mb-2 mt-6">Kết luận</label>
                <CkeditorNormal
                  id="conclusion-pdt"
                  @onEditorInput="
                    (t) => {
                      form.conclusion = t;
                    }
                  "
                  :prop_text="form.conclusion"
                  :class_style="'bg-white p-0 txt-black'"
                ></CkeditorNormal>-->

            <label class="fw-700 txt-grey-900 mb-2 mt-6">Ngày hẹn</label>
            <input type="date" :min="disabledPast" class="form--input border-solid border-2 border-gray-400"
              v-model="form.appt_date" />
          </div>
          <div class="col-md-6">
            <div class="mb-3 prettier-panel">
              <IndicationTemp ref="IndicationTest" :name="$t('Xét nghiệm')" :type="1" :reset="resetKey"
                @update="onUpdateOrders" @refresh="refresh"
                :items="this.type === 'update' ? form.emr_treatment_indications : null" />
            </div>
            <div class="mb-3 prettier-panel">
              <IndicationTemp ref="IndicationImaging" :name="$t('Chẩn đoán hình ảnh')" :type="2" :reset="resetKey"
                @update="onUpdateOrders" @refresh="refresh"
                :items="this.type === 'update' ? form.emr_treatment_images : null" />
            </div>
            <div class="mb-3 prettier-panel">
              <PrescriptionTemp ref="Prescription" :name="$t('Thuốc')" :form="form" :type="'medicine'" :reset="resetKey"
                @updatePrescriptions="onUpdatePrescriptions"
                @updateIsPhieuLinh="val => onUpdateIsPhieuLinh('medicine', val)"
                :items="this.type === 'update' ? form.emr_treatment_medicines : null" />
            </div>
            <div class="mb-3 prettier-panel">
              <PrescriptionTemp ref="PrescriptionSelfPaid" :name="$t('Thuốc tự túc')" :form="form" :type="'selfpaid'"
                :reset="resetKey" @updatePrescriptions="onUpdateSelfPaidPrescriptions"
                @updateIsPhieuLinh="val => onUpdateIsPhieuLinh('selfpaid', val)"
                :items="this.type === 'update' ? form.emr_treatment_self_medicines : null" />
            </div>

            <div class="mb-3 prettier-panel">
              <PrescriptionTemp ref="PrescriptionMaterial" :name="$t('Vật tư')" :form="form" :type="'material'"
                :reset="resetKey" @updatePrescriptions="onUpdateMaterialPrescriptions"
                @updateIsPhieuLinh="val => onUpdateIsPhieuLinh('material', val)"
                :items="this.type === 'update' ? form.emr_treatment_materials : null" />
            </div>
            <label class="fw-700 txt-grey-900 mb-2 mt-6">Chế độ ăn</label>
            <CkeditorNormal id="diet_order-pdt" @onEditorInput="(t) => { form.diet_order = t; }"
              :prop_text="form.diet_order" :class_style="'bg-white p-0 txt-black'"></CkeditorNormal>
            <label class="fw-700 txt-grey-900 mb-2 mt-6">Chế độ chăm sóc</label>
            <CkeditorNormal id="care_order-pdt" @onEditorInput="(t) => { form.care_order = t; }"
              :prop_text="form.care_order" :class_style="'bg-white p-0 txt-black'"></CkeditorNormal>
          </div>
        </div>
      </div>
      <template footer>
        <div class="flex items-center justify-end w-full pt-3">
          <button @click="onSubmit" type="button" class="btn bg-pri text-white">
            Lưu phiếu
          </button>
        </div>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import CkeditorNormal from '@/components/Editors/CkeditorNormal.vue'
import appUtils from '@/utils/appUtils'
import { MENU_EMR_TEMPLATE } from '@/utils/constants'
import { mixinHasFeatures } from '@/utils/mixinHasFeatures'
import html2pdf from 'html2pdf.js'
import _ from 'lodash'
import moment from 'moment'
import { mapState } from 'vuex'
import IndicationTemp from './Modals/IndicationTemp.vue'
import PrescriptionTemp from './Modals/PrescriptionTemp.vue'

export default {
  props: ['type'],
  name: 'ModalTreatment',
  mixins: [mixinHasFeatures],
  components: {
    CkeditorNormal,
    IndicationTemp,
    PrescriptionTemp
  },
  data () {
    return {
      outerVisible: false,
      edit: false,
      form: {
        name: 'Phiếu điều trị ' + window.moment().format('DD/MM/YYYY'),
        date: moment().format('YYYY-MM-DDTHH:mm'),
        appt_date: '',
        examination: '',
        symptom: '',
        other_disease: '',
        solution: '',
        diagnostic_code: '',
        diagnostic_name: '',
        diet_order: '',
        care_order: '',
        disease_progression: '',
        emr_treatment_medicines: [],
        emr_treatment_self_medicines: [],
        emr_treatment_materials: [],
        emr_treatment_images: [],
        emr_treatment_indications: [],
        format: 1,
        doc_template: null,
        meta_data: {},
        // EHC USAGE FIELDS
        pulse: 0,
        temperature: 0,
        diastolic_pressure: 0,
        systolic_pressure: 0,
        respiration: 0,
        height: 0,
        weight: 0,
        spo2: 0,
        note: '',
        room_id: null,
        isPhieuLinhMedicine: true,
        isPhieuLinhSelfPaid: true,
        isPhieuLinhMaterial: true
      },
      vitalSign: null,
      loading: false,
      docsTemplateList: [],
      icds: [],
      oldIndications: [],
      oldImages: [],
      oldIndicationIds: new Set(),
      oldImageIds: new Set(),
      timer: null,
      resetKey: 0
    }
  },
  computed: {
    ...mapState({
      person: (state) => state.person,
      medicalRecordMain: (state) => state.medicalRecordMain,
      emrData: (state) => state.emrData
    }),
    disabledPast () {
      const currentDate = moment().format('YYYY-MM-DD')
      return currentDate
    }
  },
  async created () {
    const self = this
    if (!self.$route.params?.id) {
      self.$router.push({ path: '/doctor/appointment-management' })
    }
    this.form.medical_record_id = Number(self.$route.params.id)
  },
  mounted () {
    this.getDocsTemplateList()
    this.getIcd10Name()
    if (this.type === 'update') {
      this.refresh()
      this.getEMRTreatmentByID()
    }
    if (this.type === 'create') {
      let self = this
      self.form.diagnostic_code = ''
      self.form.diagnostic_name = ''
      self.$nextTick(function () {
        window.$('#modalDieuTri').on('shown.bs.modal', function (e) {
          self.form.diagnostic_code = self.medicalRecordMain?.treat_dept_main_code || ''
          self.form.diagnostic_name = self.medicalRecordMain?.treat_dept_main_name || ''
          self.form.date = moment().format(`YYYY-MM-DDTHH:mm`)
          self.form.emr_treatment_images = []
          self.form.emr_treatment_indications = []
        })

        window.$('#modalDieuTri').on('hidden.bs.modal', function (e) {
          self.form.diagnostic_code = ''
          self.form.diagnostic_name = ''
          self.refresh()
        })
      })
    }
  },
  methods: {
    // State management
    refresh () {
      this.oldIndications = []
      this.oldImages = []
      this.oldIndicationIds = new Set()
      this.oldImageIds = new Set()
      Object.assign(this.form, {
        name: 'Phiếu điều trị ' + window.moment().format('DD/MM/YYYY'),
        date: moment().format('YYYY-MM-DDTHH:mm'),
        appt_date: '',
        examination: '',
        symptom: '',
        other_disease: '',
        solution: '',
        diagnostic_code: '',
        diagnostic_name: '',
        disease_progression: '',
        diet_order: '',
        care_order: '',
        format: 1,
        emr_treatment_medicines: [],
        emr_treatment_self_medicines: [],
        emr_treatment_materials: [],
        emr_treatment_images: [],
        emr_treatment_indications: [],
        // EHC USAGE FIELDS
        meta_data: this.form && typeof this.form.meta_data !== 'undefined' ? this.form.meta_data : {},
        pulse: this.form && typeof this.form.pulse !== 'undefined' ? this.form.pulse : 0,
        temperature: this.form && typeof this.form.temperature !== 'undefined' ? this.form.temperature : 0,
        diastolic_pressure: this.form && typeof this.form.diastolic_pressure !== 'undefined' ? this.form.diastolic_pressure : 0,
        systolic_pressure: this.form && typeof this.form.systolic_pressure !== 'undefined' ? this.form.systolic_pressure : 0,
        respiration: this.form && typeof this.form.respiration !== 'undefined' ? this.form.respiration : 0,
        height: this.form && typeof this.form.height !== 'undefined' ? this.form.height : 0,
        weight: this.form && typeof this.form.weight !== 'undefined' ? this.form.weight : 0,
        spo2: this.form && typeof this.form.spo2 !== 'undefined' ? this.form.spo2 : 0,
        note: this.form && typeof this.form.note !== 'undefined' ? this.form.note : ''
      })
    },
    mapData (data) {
      this.form.date = data.date ? moment(data.date).utc().format('YYYY-MM-DD HH:mm') : ''
      if (Array.isArray(data.indications)) {
        this.form.emr_treatment_indications = data.indications
        if (this.type === 'update') this.oldIndications = data.indications
      } else if (Array.isArray(data.indication_labs)) {
        this.form.emr_treatment_indications = data.indication_labs
        if (this.type === 'update') this.oldIndications = data.indication_labs
      }
      if (Array.isArray(data.images)) {
        this.form.emr_treatment_images = data.images
        if (this.type === 'update') this.oldImages = data.images
      } else if (Array.isArray(data.indication_pacs)) {
        this.form.emr_treatment_images = data.indication_pacs
        if (this.type === 'update') this.oldImages = data.indication_pacs
      }
      if (this.type === 'update') {
        try {
          this.oldIndicationIds = new Set((this.oldIndications || []).map(i => i?.id).filter(Boolean))
          this.oldImageIds = new Set((this.oldImages || []).map(i => i?.id).filter(Boolean))
        } catch (e) {
          this.oldIndicationIds = new Set()
          this.oldImageIds = new Set()
        }
      }
      if (Array.isArray(data.medicines)) {
        this.form.emr_treatment_medicines = data.medicines.filter(item => item.type === 1)
        this.form.emr_treatment_self_medicines = data.medicines.filter(item => item.type === 2)
      }
      if (Array.isArray(data.materials)) {
        this.form.emr_treatment_materials = data.materials
      }
      if (data && data.meta_data && typeof data.meta_data === 'object') {
        this.form.meta_data = { ...(this.form.meta_data || {}), ...data.meta_data }
        const md = this.form.meta_data || {}
        this.form.weight = md.CanNang || md.CanNang === 0 ? md.CanNang : this.form.weight
        this.form.height = md.ChieuCao || md.ChieuCao === 0 ? md.ChieuCao : this.form.height
        this.form.systolic_pressure = md.HuyetAp_High || md.HuyetAp_High === 0 ? md.HuyetAp_High : this.form.systolic_pressure
        this.form.diastolic_pressure = md.HuyetAp_Low || md.HuyetAp_Low === 0 ? md.HuyetAp_Low : this.form.diastolic_pressure
        this.form.pulse = md.NhipTim || md.NhipTim === 0 ? md.NhipTim : this.form.pulse
        this.form.temperature = md.NhietDo || md.NhietDo === 0 ? md.NhietDo : this.form.temperature
        this.form.respiration = md.NhipTho || md.NhipTho === 0 ? md.NhipTho : this.form.respiration
        this.form.spo2 = md.SPO2 || md.SPO2 === 0 ? md.SPO2 : this.form.spo2
        this.form.note = md.GhiChu || this.form.note
      }
    },
    deleteValueNull (array) {
      _.remove(array, item => !item.name)
    },

    // API Fetching
    async getEMRTreatmentByID () {
      let id = this.$route.query.id_treatment
      if (!id) {
        return
      }
      let med_id = this.$route.params.id
      if (!med_id) {
        return
      }
      this.loading = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getEMRTreatmentByID(id)
        .then((r) => {
          Object.assign(this.form, {
            name: r.data.name,
            ref_id: r.data.ref_id || 0,
            appt_date: r.data.appt_date
              ? appUtils.formatInputDate(r.data.appt_date)
              : '',
            date: r.data.date ? moment(r.data.date).local().format('YYYY-MM-DDTHH:mm') : '',
            disease_progression: r.data.disease_progression || '',
            examination: r.data.examination || '',
            symptom: r.data.symptom || '',
            other_disease: r.data.other_disease || '',
            solution: r.data.solution || '',
            conclusion: r.data.conclusion || '',
            diagnostic_code: r.data.diagnostic_code || '',
            diagnostic_name: r.data.diagnostic_name || '',
            diet_order: r.data.diet_order || '',
            care_order: r.data.care_order || ''
          })
          this.mapData(r.data)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getDocsTemplateList (search) {
      try {
        this.loading = true
        const params = {
          workspace_id: this.$globalClinic.id,
          limit: 1000,
          sort_by: 'desc',
          type: Number(MENU_EMR_TEMPLATE[3].value)
        }
        if (search) params.keyword = search
        const r = await this.$rf.getRequest('DoctorRequest').getDocsTemplateList(params)
        const responseData = r.data?.data?.data || []
        this.docsTemplateList = responseData.filter(
          item => item?.author_id === this.$user?.id || item?.emr_temp_name?.is_public === 1
        )
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getIcd10 (value) {
      const p = { limit: 50, code: value || this.form.diagnostic_code }
      const res = await this.$rf.getRequest('AuthRequest').getIcd10(p)
      this.icds = res?.data
    },
    async getIcd10Name (value) {
      const p = { limit: 50, name: value || this.form.diagnostic_name }
      const res = await this.$rf.getRequest('AuthRequest').getIcd10(p)
      this.icds = res?.data
    },
    async getLastVitalsign () {
      if (!this.form.medical_record_id) {
        this.$message({
          type: 'warning',
          message: 'Không lấy được thông tin của Bệnh án điện tử'
        })
        return
      }

      try {
        await this.$rf
          .getRequest('DoctorRequest')
          .getLastVitalsign(this.form.medical_record_id)
          .then(res => {
            this.vitalSign = { ...res.data?.data }
          })
      } catch (error) {
        console.log(error)
      }
    },
    async handleUseVitalsign () {
      await this.getLastVitalsign()
      this.form.pulse = this.vitalSign?.bpm || 0
      this.form.systolic_pressure = this.vitalSign?.systolic_pressure || 0
      this.form.diastolic_pressure = this.vitalSign?.diastolic_pressure || 0
      this.form.temperature = this.vitalSign?.temperature || 0
      this.form.weight = this.vitalSign?.weight || 0
    },

    // Form updates
    onUpdatePrescriptions (prescriptions) {
      this.form.emr_treatment_medicines = prescriptions
    },
    onUpdateSelfPaidPrescriptions (selfPaidPrescriptions) {
      this.form.emr_treatment_self_medicines = selfPaidPrescriptions
    },
    onUpdateMaterialPrescriptions (materialPrescriptions) {
      this.form.emr_treatment_materials = materialPrescriptions
    },
    onUpdateIsPhieuLinh (type, val) {
      if (type === 'medicine') this.form.isPhieuLinhMedicine = val
      else if (type === 'selfpaid') this.form.isPhieuLinhSelfPaid = val
      else if (type === 'material') this.form.isPhieuLinhMaterial = val
    },
    onUpdateOrders ({ type, data }) {
      if (type === 1) {
        this.$set(this.form, 'emr_treatment_indications', [...data])
      } else if (type === 2) {
        this.$set(this.form, 'emr_treatment_images', [...data])
      }
    },

    // Form submit
    async onSubmit () {
      this.form.medical_record_id = Number(this.$route.params.id)
      if (this.type === 'create') {
        this.form.user_id = this.$user?.id
        this.form.user_name = this.$user?.name
        this.form.treatment_workspace = this.$globalClinic.name
        await this.postEMRTreatment()
      } else {
        this.form.user_id = this.$user?.id
        this.form.user_name = this.$user?.name
        await this.updateEMRTreatment()
      }
      this.$emit('onSuccess')
    },
    async postEMRTreatment () {
      this.loading = true
      this.deleteValueNull(this.form.emr_treatment_medicines)
      this.deleteValueNull(this.form.emr_treatment_self_medicines)
      this.deleteValueNull(this.form.emr_treatment_materials)
      this.deleteValueNull(this.form.emr_treatment_images)
      this.deleteValueNull(this.form.emr_treatment_indications)

      const indicationsForApi = this.hasEHCConnect
        ? this.formatIndicationOrdersForEHC(this.form.emr_treatment_indications)
        : this.formatIndicationOrdersForHODO(this.form.emr_treatment_indications)
      const imagesForApi = this.hasEHCConnect
        ? this.formatIndicationOrdersForEHC(this.form.emr_treatment_images)
        : this.formatIndicationOrdersForHODO(this.form.emr_treatment_images)
      const medicinesForApi = this.getItemsForApi(this.form.emr_treatment_medicines, this.form.isPhieuLinhMedicine, true)
      const selfMedicinesForApi = this.getItemsForApi(this.form.emr_treatment_self_medicines, this.form.isPhieuLinhSelfPaid, true)
      const materialsForApi = this.getItemsForApi(this.form.emr_treatment_materials, this.form.isPhieuLinhMaterial, false)

      const params = this.buildParams({
        medicinesForApi,
        selfMedicinesForApi,
        materialsForApi,
        imagesForApi,
        indicationsForApi,
        isEHC: this.hasEHCConnect
      })

      if (this.hasEHCConnect) {
        await this.$rf
          .getRequest('DoctorRequest')
          .postEMRTreatmentEHC(params)
          .then((r) => {
            const dataId = r.data
            this.$nextTick(() => {
              this.refresh()
              this.outerVisible = false
              this.$toast.open({
                message: 'Tải lên thành công',
                type: 'success'
              })
              this.goToViewDetail(dataId)
            })
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        await this.$rf
          .getRequest('DoctorRequest')
          .postEMRTreatment(params)
          .then((r) => {
            const dataId = r.data
            this.$nextTick(() => {
              this.refresh()
              this.outerVisible = false
              this.$toast.open({
                message: 'Tải lên thành công',
                type: 'success'
              })
              this.goToViewDetail(dataId)
            })
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    async updateEMRTreatment () {
      let id = Number(this.$route.query.id_treatment)
      this.loading = true
      try {
        this.deleteValueNull(this.form.emr_treatment_medicines)
        this.deleteValueNull(this.form.emr_treatment_self_medicines)
        this.deleteValueNull(this.form.emr_treatment_materials)
        this.deleteValueNull(this.form.emr_treatment_images)
        this.deleteValueNull(this.form.emr_treatment_indications)

        const indicationsForApi = this.hasEHCConnect
          ? this.formatIndicationOrdersForEHC(this.form.emr_treatment_indications)
          : this.formatIndicationOrdersForHODO(this.form.emr_treatment_indications)
        const imagesForApi = this.hasEHCConnect
          ? this.formatIndicationOrdersForEHC(this.form.emr_treatment_images)
          : this.formatIndicationOrdersForHODO(this.form.emr_treatment_images)
        const medicinesForApi = this.getItemsForApi(this.form.emr_treatment_medicines, this.form.isPhieuLinhMedicine, true)
        const selfMedicinesForApi = this.getItemsForApi(this.form.emr_treatment_self_medicines, this.form.isPhieuLinhSelfPaid, true)
        const materialsForApi = this.getItemsForApi(this.form.emr_treatment_materials, this.form.isPhieuLinhMaterial, false)

        const rawParams = this.buildParams({
          medicinesForApi,
          selfMedicinesForApi,
          materialsForApi,
          imagesForApi,
          indicationsForApi,
          isEHC: this.hasEHCConnect
        })
        const params = {
          ...rawParams,
          emr_treatment_medicines: rawParams?.emr_treatment_medicines?.filter((item) => !item?.id)?.map((item) => {
            const { id, ...newItem } = item
            return newItem
          }) || []
        }

        if (this.hasEHCConnect) {
          await this.$rf
            .getRequest('DoctorRequest')
            .updateEMRTreatmentEHC(id, params)
            .then((r) => {
              this.$emit('refreshERM', r.data.id)
              this.$nextTick(() => {
                this.outerVisible = false
                this.$toast.open({
                  message: 'Chỉnh sửa thành công',
                  type: 'success'
                })
              })
            })
        } else {
          await this.$rf
            .getRequest('DoctorRequest')
            .updateEMRTreatment(id, params)
            .then((r) => {
              this.$emit('refreshERM', r.data.id)
              this.$nextTick(() => {
                this.outerVisible = false
                this.$toast.open({
                  message: 'Chỉnh sửa thành công',
                  type: 'success'
                })
              })
            })
            .finally(() => {
              this.$nextTick(() => {
                this.refresh()
              })
            })
        }
      } catch (err) {
        this.$toast.open({ message: 'Lỗi khi cập nhật phiếu', type: 'error' })
      } finally {
        this.loading = false
      }
    },

    // Utils
    getGender () {
      return appUtils.getGender(this.person.gender)
    },
    formatDate (date) {
      if (!date) return ''
      return window.moment(date).format('HH:mm DD/MM/YYYY')
    },
    getAge () {
      if (!this.person.birthday) return ''
      return window.moment().diff(this.person.birthday, 'years', false) || ''
    },
    getTreatDeptMain () {
      let result = ''
      if (this.medicalRecordMain?.disease_main_code) {
        result += this.medicalRecordMain.disease_main_code
      }
      if (this.medicalRecordMain?.disease_main_name) {
        result += ' ' + this.medicalRecordMain.disease_main_name
      }
      return result.trim()
    },
    handleGetTemLabel (data) {
      return data?.emr_temp_name?.name ? `${data.name} - ${data.emr_temp_name.name}` : data.name
    },
    setName (value) {
      const item = _.find(this.icds.data, ['code', value])
      this.form.diagnostic_name = item?.name || ''
    },
    setCode (value) {
      const item = _.find(this.icds.data, ['name', value])
      this.form.diagnostic_code = item?.code || 0
    },

    // Navigation
    openDialog () {
      this.outerVisible = true
      if (this.type === 'create') {
        this.refresh()
      } else if (this.type === 'update') {
        this.getEMRTreatmentByID()
      }
    },
    hideModal () {
      this.resetKey += 1
      this.refresh()
    },
    goToViewDetail (row) {
      this.$router.push({
        query: {
          tab: this.$route.query.tab,
          id_treatment: row.id,
          type: 'view'
        }
      })
      this.$emit('refreshERM', row.id)
    },
    goToView (type) {
      this.$router.replace({
        query: {
          tab: this.$route.query.tab,
          id_treatment: this.$route.query.id_treatment,
          type
        }
      })
    },
    backList () {
      this.$router.replace({ query: { tab: this.$route.query.tab } })
    },

    // PDF/Export
    exportPdf () {
      this.loading = true
      setTimeout(async () => {
        const options = {
          margin: [7, 11, 7, 7],
          filename: `Phieu_Dieu_Tri_${this.form.name}_Ngay_${this.form.date}.pdf`,
          html2canvas: {
            dpi: 1000,
            scale: 6,
            image: { type: 'png', quality: 1 },
            letterRendering: true,
            allowTaint: true,
            logging: true,
            useCORS: true
          },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        }
        await html2pdf().from(this.$refs.viewDetail).set(options).save()
        this.loading = false
      }, 10)
    },
    openFile (url) {
      window.open(url)
    },

    // Template/Selection
    handleChangeDocTemplate (selectedDoc) {
      const docTemplateInfo = this.docsTemplateList.find(item => item.id === selectedDoc) || {}
      const contentObj = docTemplateInfo.content ? JSON.parse(docTemplateInfo.content) : {}
      Object.assign(this.form, {
        name: docTemplateInfo.name,
        disease_progression: contentObj.disease_progression?.value,
        solution: contentObj.solution?.value,
        diet_order: contentObj.diet_order?.value,
        care_order: contentObj.care_order?.value
      })
    },
    searchDiseaseCodes (value) {
      return this.getIcd10(value)
    },
    searchDiseaseName (value) {
      return this.getIcd10Name(value)
    },

    // Indications/Medicines API Formatting
    existsInOldData (id) {
      if (!id) return false
      if (this.oldIndicationIds && this.oldIndicationIds.has(id)) return true
      if (this.oldImageIds && this.oldImageIds.has(id)) return true
      return false
    },
    formatIndicationOrdersForHODO (orders) {
      return (orders || [])
        .filter(order => !this.existsInOldData(order?.id))
        .map(order => {
          const indications = (order.indications || [])
            .map(ind => ({
              service_code: ind?.service_catalog?.services_code,
              quantity: ind?.indicationAmount || ind?.quantity || 1
            }))
            .filter(ind => ind.service_code)
          return {
            indication_order_name: order?.local_name || order?.name || (order?.service_catalog && order.service_catalog.name) || '',
            indications
          }
        })
        .filter(order => order.indications && order.indications.length)
    },
    formatIndicationOrdersForEHC (orders) {
      if (!Array.isArray(orders)) return []
      const map = new Map()
      for (const order of orders) {
        if (!Array.isArray(order?.indications)) continue
        for (const curr of order.indications) {
          const serviceCode = curr?.service_catalog?.services_code
          if (!serviceCode) continue
          const qty = curr?.quantity || curr?.indicationAmount || 1
          map.set(serviceCode, (map.get(serviceCode) || 0) + qty)
        }
      }
      const result = []
      for (const [service_code, quantity] of map.entries()) {
        result.push({ service_code, quantity })
      }
      return result
    },
    buildItemPayload (item, options = {}) {
      const {
        isPhieuLinh = true,
        isThuoc = true,
        diagnostic_code = this.form.diagnostic_code,
        diagnostic_name = this.form.diagnostic_name,
        date = this.form.date
      } = options
      return {
        id: item.id || 0,
        name: item.name,
        patient_visit_id: item.patient_visit_id || 0,
        medical_record_id: item.medical_record_id || this.form.medical_record_id || 0,
        person_id: item.person_id || 0,
        prescribed_doctor: item.prescribed_doctor || this.$user?.name,
        prescribed_doctor_id: item.prescribed_doctor_id || this.$user?.doctor?.id,
        prescribed_clinic: item.prescribed_clinic || this.$globalClinic?.name,
        description: item.description || '',
        MedicineStoreID: item.pharma_inventory_id || 0,
        isThuoc,
        isPhieuLinh: Boolean(isPhieuLinh),
        ChanDoan_Code: diagnostic_code || '',
        ChanDoan: diagnostic_name || '',
        NgayYLenh: moment(date).format('YYYY-MM-DDTHH:mm:ss'),
        dsThuoc: (item.person_medicine || []).map(t => ({
          MaThuoc: t.medicine?.product_info?.product_code || '',
          HuongDanSuDung: t.doctor_note || '',
          doctor_note: t.doctor_note || '',
          person_note: t.person_note || '',
          status: t.status || 1,
          amount: t.amount || 1,
          ...(isThuoc ? {
            freq_per_day: t.freq_per_day || 1,
            gap_day: t.gap_day || 0,
            amount_per_one: t.amount_per_one || 1,
            is_monitor: t.is_monitor || false,
            is_by_day: t.is_by_day || false
          } : {})
        }))
      }
    },
    getItemsForApi (items, isPhieuLinh, isThuoc = true) {
      return items.map(item => this.buildItemPayload(item, { isPhieuLinh, isThuoc }))
    },
    buildParams ({
      medicinesForApi,
      selfMedicinesForApi,
      materialsForApi,
      imagesForApi,
      indicationsForApi,
      isEHC = false
    }) {
      const {
        name, date, appt_date, examination, symptom, other_disease, solution,
        diagnostic_code, diagnostic_name, disease_progression, diet_order, care_order,
        format, medical_record_id, room_id, pulse, temperature, diastolic_pressure,
        systolic_pressure, respiration, height, weight, spo2, note
      } = this.form
      return {
        name,
        date: moment(date).format('YYYY-MM-DD HH:mm:ss'),
        appt_date: appt_date ? moment(appt_date).format('YYYY-MM-DD HH:mm:ss') : moment().format('YYYY-MM-DD HH:mm:ss'),
        examination,
        symptom,
        other_disease,
        solution,
        diagnostic_code,
        diagnostic_name,
        disease_progression,
        diet_order,
        care_order,
        format,
        emr_treatment_medicines: isEHC
          ? medicinesForApi
          : this.buildMedicinesParamsHODO(this.form.emr_treatment_medicines),
        emr_treatment_self_medicines: isEHC
          ? selfMedicinesForApi
          : this.buildMedicinesParamsHODO(this.form.emr_treatment_self_medicines),
        emr_treatment_materials: isEHC ? materialsForApi : this.buildMaterialsParamsHODO(this.form.emr_treatment_materials),
        emr_treatment_images: isEHC ? imagesForApi : this.formatIndicationOrdersForHODO(this.form.emr_treatment_images),
        emr_treatment_indications: isEHC ? indicationsForApi : this.formatIndicationOrdersForHODO(this.form.emr_treatment_indications),
        medical_record_id,
        treatment_workspace: this.$globalClinic?.name,
        clinic_id: this.$globalClinic?.id,
        room_id: room_id || 0,
        pulse,
        temperature,
        diastolic_pressure,
        systolic_pressure,
        respiration,
        height,
        weight,
        spo2,
        note,
        ...(isEHC && this.type === 'update' ? { phieu_dieu_tri_id: Number(this.form.ref_id) || 0 } : {})
      }
    },
    buildMedicinesParamsHODO (medicines) {
      function filterMedicineFields (med) {
        if (!med) return null
        return {
          id: med.id,
          national_pharma_code: med.product_info?.national_pharmacy_code,
          name: med.product_info?.name,
          pharma_reg_number: med.product_info?.registration_number,
          active_ingredient: med.product_info?.active_ingredient,
          packing: med.product_info?.packing,
          concentration: med.product_info?.concentration,
          unit_name: med.product_info?.unit_name,
          side_effect: med.product_info?.side_effect,
          product_info: med.product_info ? {
            product_code: med.product_info.product_code,
            name: med.product_info.name,
            quality: med.product_info.quality,
            active_ingredient: med.product_info.active_ingredient,
            unit_id: med.product_info.unit_id,
            isExternal: med.product_info.isExternal
          } : {}
        }
      }
      return medicines.map(item => ({
        id: item.id || 0,
        person_id: item.person_id || 0,
        patient_visit_id: item.patient_visit_id || 0,
        name: item.name,
        date: moment(item.date).format('YYYY-MM-DD HH:mm:ss'),
        prescribed_doctor: item.prescribed_doctor,
        prescribed_doctor_id: item.prescribed_doctor_id,
        prescribed_clinic: item.prescribed_clinic,
        pharma_inventory_id: item.pharma_inventory_id,
        document_ids: item.document_ids || [],
        person_medicine: (item.person_medicine || []).map(t => ({
          id: t.id,
          name: t.name,
          amount_unit: t.amount_unit,
          doctor_note: t.doctor_note,
          freq_per_day: t.freq_per_day,
          amount_per_one: t.amount_per_one,
          is_monitor: t.is_monitor ? 1 : 0,
          amount: t.amount,
          gap_type: t.gap_type,
          total: t.total,
          medicine: filterMedicineFields(t.medicine),
          is_by_day: t.is_by_day ? 1 : 0,
          route_of_use: t.route_of_use,
          pharma_inventory_product_id: t.pharma_inventory_product_id,
          active_ingredient: t.active_ingredient,
          quality: t.quality,
          gap_day: t.gap_day,
          amountMorning: t.amountMorning || 0,
          amountNoon: t.amountNoon || 0,
          amountAfternoon: t.amountAfternoon || 0,
          amountEvening: t.amountEvening || 0,
          time1: t.time1 || 0,
          time2: t.time2 || 0,
          time3: t.time3 || 0,
          time4: t.time4 || 0
        }))
      }))
    },
    buildMaterialsParamsHODO (materials) {
      return materials.map(item => ({
        date: moment(item.date).format('YYYY-MM-DDTHH:mm:ss'),
        name: item.name,
        patient_visit_id: item.patient_visit_id || 0,
        person_id: item.person_id || 0,
        pharma_inventory_id: item.pharma_inventory_id || 0,
        prescribed_doctor: item.prescribed_doctor || '',
        prescribed_doctor_id: item.prescribed_doctor_id || 0,
        prescribed_clinic: item.prescribed_clinic || '',
        description: item.description || '',
        person_materials: (item.person_medicine || []).map(t => ({
          person_id: t.person_id || 0,
          person_diseases_id: t.person_diseases_id || 0,
          doctor_note: t.doctor_note || '',
          person_note: t.person_note || '',
          quantity: t.quantity || 0,
          status: t.status || 1,
          name: t.name || '',
          amount_unit: t.amount_unit || '',
          start_date: t.start_date || '',
          material_id: t.material_id || 0,
          pharma_product_id: t.pharma_product_id || 0,
          route_of_use: t.route_of_use || ''
        }))
      }))
    }
  }
}
</script>
